module.exports = ".list-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: wrap;\n      flex-flow: wrap;\n  padding: 0 8px; }\n\n.more-button {\n  float: right;\n  margin-top: -15px;\n  cursor: pointer;\n  margin-bottom: 15px; }\n\n.list-item {\n  width: 178px;\n  padding: 0 8px; }\n  @media (max-width: 768px) {\n    .list-item {\n      width: 49.8%; }\n      .list-item.curated-list {\n        width: 99.5%; } }\n\n@media (min-width: 768px) {\n  .container {\n    padding: 0; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/row/row.component.scss
// module id = 696
// module chunks = 2